import React, { useState, useEffect } from 'react';
import Header from '../../components/ui/Header';
import ArchiveHero from './components/ArchiveHero';
import DocumentCard from './components/DocumentCard';
import coachesData  from "../../data/coaches";
import Footer from "../../components/ui/Footer";
import WhatsAppButton from "../../components/ui/WhatsAppButton";

const HistoricalResearchArchive = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [coaches, setCoaches] = useState([]);

  useEffect(() => {
    const loadCoaches = async () => {
      setIsLoading(true);
      await new Promise(resolve => setTimeout(resolve, 1000));
      setCoaches(coachesData );
      setIsLoading(false);
    };

    loadCoaches();
  }, []);

  return (
    <>
      <div className="min-h-screen bg-background">
        <Header />
        
        <main className="pt-16 lg:pt-20">
          {/* Hero Section */}
          <ArchiveHero />

          {/* Documents Grid */}
          <section className="py-16 ">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
              <div className="flex items-center justify-between mb-8">
                <div>
                  <h2 className="font-headline text-2xl lg:text-3xl font-bold text-primary mb-2">
                    Talleres Actuales
                  </h2>
                  <p className="font-body text-scholarly-gray">
                    {isLoading ? 'Cargando talleres...'
                        : `${coaches.filter((coach) => coach?.is_new === true).length} talleres`}
                  </p>
                </div>
              </div>

              {isLoading ? (
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                  {[...Array(6)]?.map((_, index) => (
                    <div key={index} className=" rounded-lg literary-shadow literary-border overflow-hidden animate-pulse">
                      <div className="h-48 bg-muted"></div>
                      <div className="p-6 space-y-4">
                        <div className="h-4 bg-muted rounded w-3/4"></div>
                        <div className="h-3 bg-muted rounded w-full"></div>
                        <div className="h-3 bg-muted rounded w-2/3"></div>
                        <div className="flex space-x-2">
                          <div className="h-6 bg-muted rounded w-16"></div>
                          <div className="h-6 bg-muted rounded w-20"></div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                  {coaches
                      ?.filter((coach) => coach?.is_new === true)
                      ?.map((coach) => (
                          <DocumentCard key={coach?.id} coach={coach} />
                      ))}
                </div>
              )}
            </div>
          </section>

          <section className="py-16 ">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
              <div className="flex items-center justify-between mb-8">
                <div>
                  <h2 className="font-headline text-2xl lg:text-3xl font-bold text-primary mb-2">
                    Talleres Pasados
                  </h2>
                  <p className="font-body text-scholarly-gray">
                    {isLoading ? 'Cargando talleres...'
                        : `${coaches.filter((coach) => coach?.is_new === false).length} talleres`}
                  </p>
                </div>
              </div>

              {isLoading ? (
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                    {[...Array(6)]?.map((_, index) => (
                        <div key={index} className="bg-white rounded-lg literary-shadow literary-border overflow-hidden animate-pulse">
                          <div className="h-48 bg-muted"></div>
                          <div className="p-6 space-y-4">
                            <div className="h-4 bg-muted rounded w-3/4"></div>
                            <div className="h-3 bg-muted rounded w-full"></div>
                            <div className="h-3 bg-muted rounded w-2/3"></div>
                            <div className="flex space-x-2">
                              <div className="h-6 bg-muted rounded w-16"></div>
                              <div className="h-6 bg-muted rounded w-20"></div>
                            </div>
                          </div>
                        </div>
                    ))}
                  </div>
              ) : (
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                    {coaches
                        ?.filter((coach) => coach?.is_new === false)
                        ?.map((coach) => (
                        <DocumentCard key={coach?.id} coach={coach} />
                    ))}
                  </div>
              )}
            </div>
          </section>
          <WhatsAppButton />
        </main>
        <Footer/>
      </div>
    </>
  );
};

export default HistoricalResearchArchive;